<div id="billing" class="row" [formGroup]="shipmentForm">
  <div class="col-md-9 form-group secondary-details">
    <span>{{ 'shipment.billingDetails.billingDetails' | translate }}</span>
  </div>
  <div class="col-md-4 form-group">
    <label class="required-field">{{
      'shipment.billingDetails.shipperAccountNumber' | translate
    }}</label
    >:
    <input formControlName="shipperAccountNumber" class="form-control" type="text" />
    <app-error-component [controlName]="shipmentForm.get('shipperAccountNumber')">
    </app-error-component>
  </div>

  <div class="col-md-4 form-group">
    <label class="required-field">{{
      'shipment.billingDetails.payerAccountNumber' | translate
    }}</label
    >:
    <input formControlName="payerAccountNumber" class="form-control" type="text" />
    <app-error-component [controlName]="shipmentForm.get('payerAccountNumber')">
    </app-error-component>
  </div>

  <div class="col-md-4 form-group">
    <label>{{ 'shipment.billingDetails.dutyAccountNumber' | translate }}</label
    >:
    <input formControlName="dutyAccountNumber" class="form-control" type="text" />
    <app-error-component [controlName]="shipmentForm.get('dutyAccountNumber')">
    </app-error-component>
  </div>
</div>
